"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onAdBegin;
function onAdBegin(event) {
  // As of JWPlayer 7, we no longer get ad controls by default
  // We need to add controls so that if a user clicks an ad they have
  // a way to continue playing
  this.rawPlayer.setControls(true);
  this.emit('adbegin', event);
}